import MuiLink from '@mui/material/Link';
import { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Table } from '../../../shared/components';
import { formatEmploymentPeriod } from '../employees.utils';

export default function EmployeesTable({ employeesData = {}, status, loading }) {
  const [searchParams] = useSearchParams();
  const activeData = useMemo(() => employeesData[status] ?? [], [employeesData, status]);

  const columns = [
    { id: 'employeeId', dataKey: 'employeeId', label: 'Employee ID', sortable: true },
    { id: 'name', dataKey: 'name', label: 'Employee name', sortable: true },
    { id: 'contact', dataKey: 'contact', label: 'Contact' },
    { id: 'email', dataKey: 'email', label: 'Email ID' },
    { id: 'department', dataKey: 'department', label: 'Department', sortable: true },
    { id: 'designation', dataKey: 'designation', label: 'Designation', sortable: true },
    {
      id: 'employmentPeriod',
      dataKey: 'employmentPeriod',
      label: 'Employment Period',
      renderCell: (val) => formatEmploymentPeriod(val, { orientation: 'vertical' }),
    },
    {
      id: 'action',
      dataKey: 'id',
      label: 'More details',
      renderCell: (_, row) => (
        <MuiLink
          component={Link}
          to={{ pathname: `/employees/${row.id}`, search: searchParams.toString() }}
          sx={{
            color: 'grey.500',
            '&:visited': { color: 'grey.500' },
            textDecoration: 'underline',
          }}
        >
          view
        </MuiLink>
      ),
    },
  ];

  const emptyMessage = useMemo(() => {
    switch (status) {
      case 'active':
        return 'No active employees found.';
      case 'inactive':
        return 'No inactive employees found.';
      default:
        return 'No employees found.';
    }
  }, [status]);

  return (
    <Table
      columns={columns}
      data={activeData || []}
      loading={loading}
      emptyMessage={emptyMessage}
      resetSortKey={status}
    />
  );
}
